import React, {useMemo} from "react";
import {
    ActionRow,
    ActionRowButton,
    Card,
    FormLayout,
    FormLayoutSectionFormatProps,
    Icon,
    InputLabel,
    PageHeading,
    TabControl,
    TabControlButton,
    TabControlPage,
    Table,
    TableLink,
    TextField
} from "peggirkit";
import {generateBreadcrumbs} from "@widgets/layout/Breadcrumbs";
import router, {Route} from "@/routing/Router";
import {useIntl} from "react-intl";
import {CalendarDaysIcon, CheckIcon, ClockIcon} from "@heroicons/react/24/outline";
import FormLayoutSection, {
    defaultColumnSizing
} from "peggirkit/dist/components/Form/Layout/LayoutSection/FormLayoutSection";
import {FormLayoutProps} from "peggirkit/dist/components/Form/Layout/FormLayout";
import {useRestaurant} from "@/context/restaurant/RestaurantProvider";
import {PencilIcon} from "@heroicons/react/16/solid";
import LocationPageMeta from "@widgets/heading/meta/LocationPageMeta";

export const defaultFormGridClassname = "w-full grid grid-cols-1 md:grid-cols-2 gap-x-5 gap-y-8";
export const FormGridFiller = () => (
    <div className={"hidden md:block"}></div>
);

const LocationOverview = () => {
    const intl = useIntl();
    const {dashboardLocation} = useRestaurant();
    const route: Route = useMemo(() => router.location, []);
    const defaultFormLayoutProps: Omit<FormLayoutProps, "children"> = {
        type: "stacked",
        sectionColumnSizing: {
            ...defaultColumnSizing,
            horizontal: {
                ...defaultColumnSizing.horizontal,
                gapClassname: "gap-12",
                containerCols: 9,
                titleColSpan: 2,
                contentColSpan: 7,
            },
        },
        breakpoints: {xl: {type: "horizontal"}},
    }

    return (
        <>
            <PageHeading
                breadcrumbs={generateBreadcrumbs(route, intl)}
                title={route.name(intl)}
                actionRow={
                    <ActionRow>

                        <ActionRowButton
                            iconBefore={<Icon icon={CheckIcon}/>}
                            loading={false}
                            buttonAction={{
                                as: "button",
                                actionProps: {
                                    onClick: () => {
                                        alert("SAVE")
                                    }
                                },
                            }}
                        >
                            Opslaan
                            {/*<FormattedMessage id={"refreshStatus"}/>*/}
                        </ActionRowButton>
                    </ActionRow>
                }
                actionRowHorizontal={false}
                breakpoints={{"2xl": {actionRowHorizontal: true}}}
                meta={<LocationPageMeta/>}
            />


            <FormLayout
                {...defaultFormLayoutProps}
                className={"mt-6 md:mt-12"}
            >
                {(layoutProps: FormLayoutSectionFormatProps) => (
                    <Card>
                        <FormLayoutSection
                            {...layoutProps}
                            noBorder
                            noPadding
                            title={"Algemene gegevens"}
                            description={"Publieke gegevens die op de website worden getoond."}
                        >
                            <div className={defaultFormGridClassname}>
                                <TextField
                                    type={"text"}
                                    label={<InputLabel>Naam</InputLabel>}
                                    defaultValue={dashboardLocation.name}
                                />

                                <FormGridFiller/>

                                {/*<TextField*/}
                                {/*    type={"text"}*/}
                                {/*    label={<InputLabel>E-mailadres</InputLabel>}*/}
                                {/*    defaultValue={dashboardLocation !== "loading" ? dashboardLocation.emailAddress : undefined}*/}
                                {/*/>*/}

                                {/*<TextField*/}
                                {/*    type={"text"}*/}
                                {/*    label={<InputLabel>Telefoonnummer</InputLabel>}*/}
                                {/*    defaultValue={dashboardLocation !== "loading" ? dashboardLocation.phoneNumber : undefined}*/}
                                {/*/>*/}

                                {/*<TextField*/}
                                {/*    type={"text"}*/}
                                {/*    label={<InputLabel>KvK-nummer</InputLabel>}*/}
                                {/*    defaultValue={dashboardLocation !== "loading" ? dashboardLocation.cocNumber : undefined}*/}
                                {/*/>*/}

                                {/*<TextField*/}
                                {/*    type={"text"}*/}
                                {/*    label={<InputLabel>Btw-nummer</InputLabel>}*/}
                                {/*    defaultValue={dashboardLocation !== "loading" ? dashboardLocation.taxNumber : undefined}*/}
                                {/*/>*/}

                                {/*<TextField*/}
                                {/*    type={"text"}*/}
                                {/*    label={<InputLabel>Adresregel 1</InputLabel>}*/}
                                {/*    defaultValue={dashboardLocation !== "loading" ? dashboardLocation.addressLine1 : undefined}*/}
                                {/*/>*/}

                                {/*<TextField*/}
                                {/*    type={"text"}*/}
                                {/*    label={<InputLabel>Adresregel 2</InputLabel>}*/}
                                {/*    defaultValue={dashboardLocation !== "loading" ? dashboardLocation.addressLine2 : undefined}*/}
                                {/*/>*/}
                            </div>
                        </FormLayoutSection>
                    </Card>
                )}
            </FormLayout>

            <TabControl
                containerClassname={"mt-6 md:mt-12"}
                tabPanelsContainerClassname={"pt-12"}
                tabsListStyle={{type: "select-list"}}
                breakpoints={{md: {tabsListStyle: {type: "button-row"}}}}
                // panelWrapper={children => <SlimContainer>{children}</SlimContainer>}
            >
                <TabControlPage
                    tabButton={
                        <TabControlButton iconBefore={<Icon icon={ClockIcon}/>}>
                            Standaard openingstijden
                        </TabControlButton>
                    }
                    unmount={false}
                    // disabled={saving || initialLoading}
                >
                    <Table<{ day: string, restaurant: string, delivery: string, edit: string }>
                        columns={[
                            {
                                id: "day",
                                label: {displayName: "Dag"},
                                primary: true,
                            },
                            {
                                id: "restaurant",
                                label: {displayName: "Restaurant"},
                                // primary: true,
                            },
                            {
                                id: "delivery",
                                label: {displayName: "Bezorging"},
                                // primary: true,
                            },
                            {
                                id: "edit",
                                label: {displayName: "Bewerken"},
                                // primary: true,
                                align: "right"
                            },
                        ]}
                        setData={() => {
                            console.log("ALERT")
                        }}
                        data={[
                            {
                                day: "Maandag",
                                restaurant: "16:00 - 21:00",
                                delivery: "16:00 - 21:00",
                                edit: <TableLink buttonAction={{as: "button"}}
                                                 iconBefore={<Icon icon={PencilIcon}/>}>Bewerken</TableLink>
                            },
                            {
                                day: "Dinsdag",
                                restaurant: "16:00 - 21:00",
                                delivery: "16:00 - 21:00",
                                edit: <TableLink buttonAction={{as: "button"}}
                                                 iconBefore={<Icon icon={PencilIcon}/>}>Bewerken</TableLink>
                            },
                            {
                                day: "Woensdag",
                                restaurant: "16:00 - 21:00",
                                delivery: "16:00 - 21:00",
                                edit: <TableLink buttonAction={{as: "button"}}
                                                 iconBefore={<Icon icon={PencilIcon}/>}>Bewerken</TableLink>
                            },
                            {
                                day: "Donderdag",
                                restaurant: "16:00 - 21:00",
                                delivery: "16:00 - 21:00",
                                edit: <TableLink buttonAction={{as: "button"}}
                                                 iconBefore={<Icon icon={PencilIcon}/>}>Bewerken</TableLink>
                            },
                            {
                                day: "Vrijdag",
                                restaurant: "16:00 - 21:00",
                                delivery: "16:00 - 21:00",
                                edit: <TableLink buttonAction={{as: "button"}}
                                                 iconBefore={<Icon icon={PencilIcon}/>}>Bewerken</TableLink>
                            },
                            {
                                day: "Zaterdag",
                                restaurant: "16:00 - 21:00",
                                delivery: "16:00 - 21:00",
                                edit: <TableLink buttonAction={{as: "button"}}
                                                 iconBefore={<Icon icon={PencilIcon}/>}>Bewerken</TableLink>
                            },
                            {
                                day: "Zondag",
                                restaurant: "16:00 - 21:00",
                                delivery: "16:00 - 21:00",
                                edit: <TableLink buttonAction={{as: "button"}}
                                                 iconBefore={<Icon icon={PencilIcon}/>}>Bewerken</TableLink>
                            },
                        ]}
                    />
                </TabControlPage>


                <TabControlPage
                    tabButton={
                        <TabControlButton iconBefore={<Icon icon={CalendarDaysIcon}/>}>
                            Uitzonderlijke openingstijden
                        </TabControlButton>
                    }
                    unmount={false}
                    // disabled={saving || initialLoading}
                >
                    Uitzonderingen
                </TabControlPage>
            </TabControl>
        </>
    );
};

export default LocationOverview;